import React from 'react';

const GlyphIcon = class extends React.Component {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox={ this.props.viewBox ?? "0 0 32 32" }
				fill={ this.props.fill ?? "currentColor" }
				stroke={ this.props.stroke  ?? "none" }
				style={{...this.props.style }}
			>
				<path d={this.props.d}/>
			</svg>
		);
	}
}

export default GlyphIcon;